import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ManageEnvironmentTypesDialogData } from '@app/shared/components/dialogs/manage-environment-types-dialog/manage-environment-types-dialog.data';

@Component({
    selector : 'manage-environment-types-dialog',
    template: require('./manage-environment-types-dialog.component.html'),
    styles: [require('./manage-environment-types-dialog.component.scss')]
})
export class ManageEnvironmentTypesDialogComponent {
    public selectedTemplateId: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: ManageEnvironmentTypesDialogData) {
    }

    public selectTemplateType(templateId) {
        if (this.selectedTemplateId === templateId) {
            return;
        }
        this.selectedTemplateId = templateId
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/manage-environment-types-dialog/manage-environment-types-dialog.component.ts